import { ref } from 'vue'

/**
 * Composable for managing the GTM/GA4 dataLayer.
 * Allows pushing event data and tracking customer behavior.
 */
export function useDataLayer() {
  // Ensure window.dataLayer exists
  const initDataLayer = () => {
    window.dataLayer = window.dataLayer || []
  }

  /**
   * Push an event and optional payload to the dataLayer.
   * @param {string} eventName - The event name (e.g. 'purchase', 'add_to_cart')
   * @param {Object} [payload={}] - Additional details of the event
   */
  const pushEvent = (eventName, payload = {}) => {
    initDataLayer()
    try {
      window.dataLayer.push({
        event: eventName,
        ...payload,
        timestamp: new Date().toISOString()
      })
    } catch (e) {
      console.error('Failed to push to dataLayer:', e)
    }
  }

  /**
   * Track virtual page view for SPAs
   * @param {string} path - URL path (e.g. '/product/123')
   * @param {string} title - Page title
   */
  const trackPageView = (path, title) => {
    pushEvent('page_view', {
      page_path: path,
      page_title: title,
      page_location: window.location.href
    })
  }

  return {
    pushEvent,
    trackPageView
  }
}
